import React, { FunctionComponent, useContext } from 'react';
import { Link, useLocation, matchRoutes } from 'react-router-dom';
import { ShoppingPlannerContext } from '../../Context/ShoppingPlannerContext';
import { useProductsFromStates } from '../../Hook/UseProductsFromStates';
import { useResponsive } from '../../Hook/UseResponsive';
import { Icon } from '../Icon/Icon';
import { urls } from '../../Constants/Urls';
import { NavButton } from '../NavButton/NavButton';

import './Infobar.scss';

export const InfoBar: FunctionComponent = () => {
    const { setShoppingListMobileVisible, locked, slug } = useContext(ShoppingPlannerContext);

    const { floor, decor, insulation, skirting, skirtingDecor, installationAndCare, sqm } = useProductsFromStates();

    const { isLargerThanMd } = useResponsive();

    const location = useLocation();

    const currentUrl = Object.values(urls.steps).find((route) => matchRoutes([{ path: route.pattern }], location));
    const nextUrl = currentUrl ? Object.values(urls.steps).at(Object.values(urls.steps).indexOf(currentUrl) + 1) : null;
    const lastStepReached = nextUrl
        ? Object.values(urls.steps).indexOf(nextUrl) === Object.values(urls.steps).length - 1
        : false;

    const itemCount = (decor ? 1 : 0) + (insulation ? 1 : 0) + (skirting ? 1 : 0) + installationAndCare.length;

    return (
        <footer className={['shopping-planner-info-bar', sqm ? 'shopping-planner-info-bar--visible' : ''].join(' ')}>
            <div className="shopping-planner-info-bar__inner">
                {isLargerThanMd ? (
                    <div className="shopping-planner-info-bar__selection">
                        <h4 className="shopping-planner-info-bar__headline">Ihre Auswahl</h4>{' '}
                        {sqm ? (
                            <Link className="shopping-planner-info-bar__room-size" to={urls.steps.room.builder()}>
                                <span className="shopping-planner-info-bar__label">{sqm}m²</span>
                                <span className="shopping-planner-info-bar__sub-label">Raumgröße</span>
                            </Link>
                        ) : null}
                        {floor && decor ? (
                            <Link className="shopping-planner-info-bar__item" to={urls.steps.floor.builder()}>
                                <img
                                    className="shopping-planner-info-bar__selection-image"
                                    src={decor.imageUri ?? ''}
                                />
                                <div>
                                    <span className={['shopping-planner-info-bar__label'].join(' ')}>
                                        {floor.floorFamilyLabel}
                                    </span>
                                    <span className="shopping-planner-info-bar__sub-label">{decor.label}</span>
                                </div>
                            </Link>
                        ) : null}
                        {insulation ? (
                            <Link
                                className="shopping-planner-info-bar__item"
                                to={urls.steps.accessoriesInsulation.builder()}
                            >
                                <img
                                    height={43}
                                    width={43}
                                    className="shopping-planner-info-bar__selection-image"
                                    src={insulation.imageUri ?? ''}
                                />
                                <div>
                                    <span
                                        className={[
                                            'shopping-planner-info-bar__label',
                                            'shopping-planner-info-bar__label--uppercase',
                                        ].join(' ')}
                                    >
                                        {insulation.label}
                                    </span>
                                    <span className="shopping-planner-info-bar__sub-label">Dämmung</span>
                                </div>
                            </Link>
                        ) : null}
                        {skirtingDecor ? (
                            <Link
                                className="shopping-planner-info-bar__item"
                                to={urls.steps.accessoriesSkirting.builder()}
                            >
                                <img
                                    height={43}
                                    width={43}
                                    className="shopping-planner-info-bar__selection-image"
                                    src={skirtingDecor.imageUri ?? ''}
                                />
                                <div>
                                    <span
                                        className={[
                                            'shopping-planner-info-bar__label',
                                            'shopping-planner-info-bar__label--uppercase',
                                        ].join(' ')}
                                    >
                                        {skirting?.label}
                                    </span>
                                    <span className="shopping-planner-info-bar__sub-label">Leisten</span>
                                </div>
                            </Link>
                        ) : null}
                        {installationAndCare.length > 0
                            ? installationAndCare.map((installation) => (
                                  <Link
                                      key={installation.accessoryId}
                                      className="shopping-planner-info-bar__item"
                                      to={urls.steps.accessoriesInstallation.builder()}
                                  >
                                      <img
                                          height={43}
                                          width={43}
                                          className="shopping-planner-info-bar__selection-image"
                                          src={installation.imageUri ?? ''}
                                      />
                                      <div>
                                          <span
                                              className={[
                                                  'shopping-planner-info-bar__label',
                                                  'shopping-planner-info-bar__label--uppercase',
                                              ].join(' ')}
                                          >
                                              {installation.label}
                                          </span>
                                          <span className="shopping-planner-info-bar__sub-label">
                                              Verlegung & Pflege
                                          </span>
                                      </div>
                                  </Link>
                              ))
                            : null}
                    </div>
                ) : (
                    <button
                        type="button"
                        className="shopping-planner-info-bar__mobile-shopping-list-toggle"
                        onClick={() => setShoppingListMobileVisible(true)}
                    >
                        {itemCount ? (
                            <span className="shopping-planner-info-bar__item-count-bubble">{itemCount}</span>
                        ) : null}
                        <Icon icon="shopping-planer" />
                    </button>
                )}

                {nextUrl && !locked ? (
                    <NavButton to={lastStepReached ? urls.steps.shoppingList.builder(slug) : nextUrl.builder()}>
                        {lastStepReached ? 'Einkaufszettel' : 'Weiter'}
                    </NavButton>
                ) : null}
            </div>
        </footer>
    );
};
